<template>
  <div>
    <mainVue>
      <template v-slot:main="main">
        <specialVue :data-list="main.data"></specialVue>
      </template>
    </mainVue>
  </div>
</template>

<script>
  import mainVue from '../../../components/resource/main.vue'
  import specialVue from '../../../components/resource/special.vue';

  export default {
    name: 'PortalInBooks',
    components: {
      specialVue, mainVue
    },
    data() {
      return {};
    },

    mounted() {
    },

    methods: {},
  };
</script>

<style lang="less" scoped>

</style>
